import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSplunkComponent } from './simple-icons-splunk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSplunkComponent ],
    exports:      [ SimpleIconsSplunkComponent ],
    bootstrap:    []
})
export class SimpleIconsSplunkModule {}
